var map = {
	"./dk1050.jpg": 6931,
	"./dk2048.jpg": 5285,
	"./dk4050.jpg": 5440,
	"./dk4055.jpg": 6337,
	"./dk5021.jpg": 4475,
	"./dks26.jpg": 9716,
	"./dks40.jpg": 5940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3399;